/* ============================================================
   LAS ESTRELLAS LLEVAN A LAS RESENAS (1 sep 2026, pedido suyo)

   Al pulsar la fila de estrellas + "Mas de 10.000 clientas satisfechas" la
   pagina baja hasta la seccion de resenas.

   🚩 NO CALCULAR LA POSICION A MANO. Primera version fallida del 1 sep 2026:
   buscaba el contenedor que hace scroll y le ponia `scrollTo`. Elegia
   `.page-wrapper` porque en la vista previa se declara `overflow-y:auto` con
   11.139 px de contenido en 720 de alto... pero en la web REAL ese mismo
   elemento mide 17.076 px de alto y 17.076 de contenido: no hace scroll, lo
   hace el documento. Resultado: no se movia nada.

   La vía nativa acierta sola sea quien sea el que se desplaza:
     - `scrollIntoView` deja que el navegador elija el contenedor correcto.
     - `scroll-margin-top` en el destino reserva el hueco de la cabecera fija,
       sin medir nada ni restar pixeles.

   ⚠️ LA SECCION DE RESENAS LLEVA `content-visibility:auto` (lo pone
   theme.liquid para que la ficha, de ~9.500 px, no se pinte entera de golpe)
   con `contain-intrinsic-size: auto 600px`. Esos 600 px son una altura
   RESERVADA, no la real: al pintarse la seccion la pagina se recoloca y el
   primer salto se queda corto. Por eso se repite el salto al terminar.

   ⚠️ EL SELECTOR DEL DESTINO ES `[id$="nusa_reviews_section"]`, el mismo que
   usa theme.liquid. El id completo lleva dentro el id de la plantilla
   (`shopify-section-template--22357152203006__nusa_reviews_section`) y ese
   numero CAMBIA si se duplica la plantilla. No fijarlo nunca entero.
   ============================================================ */
(function () {
  'use strict';

  if (window.__pnIrResenas) { return; }
  window.__pnIrResenas = true;

  var CSS =
    /* El hueco de la cabecera fija (mide 74 px) lo reserva el navegador. */
    '[id$="nusa_reviews_section"]{scroll-margin-top:90px}' +
    '.producto-nazalea__fila-social[data-pn-ir]{cursor:pointer}' +
    '.producto-nazalea__fila-social[data-pn-ir]:hover .producto-nazalea__resenas-texto{' +
    'text-decoration:underline;text-underline-offset:3px}' +
    '.producto-nazalea__fila-social[data-pn-ir]:focus-visible{' +
    'outline:2px solid var(--pn-acento,#B98E7E);outline-offset:4px;border-radius:6px}';

  function ir() {
    var destino = document.querySelector('[id$="nusa_reviews_section"]');
    if (!destino) { return; }
    destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(function () {
      destino.scrollIntoView({ behavior: 'auto', block: 'start' });
    }, 650);
  }

  function arrancar() {
    var fila = document.querySelector('.producto-nazalea__fila-social');
    if (!fila || fila.getAttribute('data-pn-ir') === '1') { return; }

    if (!document.getElementById('pn-ir-resenas-css')) {
      var estilo = document.createElement('style');
      estilo.id = 'pn-ir-resenas-css';
      estilo.textContent = CSS;
      document.head.appendChild(estilo);
    }

    fila.setAttribute('data-pn-ir', '1');
    fila.setAttribute('role', 'button');
    fila.setAttribute('tabindex', '0');
    fila.setAttribute('aria-label', 'Ver las reseñas');

    fila.addEventListener('click', ir);
    fila.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        ir();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
  setTimeout(arrancar, 900);
})();
